
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src2984367493/src/vl-app/pages/confirm-email/index.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import * as actions from '@actions';
import * as actionTypes from '@actionTypes';
import { FaRegCheckCircle } from 'react-icons/fa';
import { AiOutlineWarning } from 'react-icons/ai';
import { Button } from 'antd';
import { getLogger } from 'loglevel';
import styled from '@emotion/styled';
import Header from '@components/Layouts/Header/Header';

const log = getLogger(__filename);

function ConfirmEmail() {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const [success, setSuccess] = useState<boolean | null>(null);
  const router = useRouter();
  const { token } = router.query;
  const [email, setEmail] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      const res = await dispatch(actions.confirmEmailChange(token));
      const tempSuccess = res.type === actionTypes.CONFIRM_EMAIL_CHANGE_SUCCESS;
      if (tempSuccess && res.payload && typeof res.payload === 'string') {
        setEmail(res.payload);
        setSuccess(true);
      } else {
        log.error(res.payload);
        setSuccess(false);
      }
    };
    if (token) {
      fetchData().then();
    }
  }, [dispatch, token]);

  return (
    <StyledConfirmEmail>
      <Header pageType="login" className="login-header" pageTitle="Confirm Email" />
      <section className="section-layout login-layout">
        <br />
        {success && (
          <div className="center-grid">
            <FaRegCheckCircle style={{ fontSize: 100 }} />
            <h1 className="title">
              <span className="orange">{t('Email Address Changed')}</span>
              {t(' Successfully')}
            </h1>
            {t('Your new email address is ')}
            <span style={{ fontWeight: 600 }}>{email}</span>
            <Button style={{ width: 200, marginTop: 50 }} onClick={() => router.push('/login')} data-testid="login">
              {t('Login_2')}
            </Button>
            <p style={{ marginTop: 10 }}>{t('If you are not a guest user, you can use the login button to sign in')}</p>
          </div>
        )}
        {!success && success !== null && (
          <div className="center-grid" style={{ fontSize: 30, color: '#db6f20' }}>
            <AiOutlineWarning style={{ fontSize: 100 }} />
            {t('Your token is not valid. Please try again.')}
          </div>
        )}
      </section>
    </StyledConfirmEmail>
  );
}

const StyledConfirmEmail = styled.div`
  .login-header {
    border-bottom: 1px solid #707070;

    .nav-panel {
      display: none !important;
    }
  }

  .title {
    font-weight: 600;
    font-size: 25px;
    margin-top: 25px;
    margin-bottom: 50px;
  }

  .center-grid {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: grid;
    place-items: center;
  }

  .login-grid {
    @media (min-width: 1921px) {
      max-width: 20%;
    }
  }

  .login-layout {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100vh - 75px + var(--footer-height, 50px));
    font-family: 'Montserrat';
    background: #fff;

    @media (max-width: 768px) {
      height: unset;
    }

    .login-title {
      font-weight: bold;
      font-size: 30px;
      color: var(--productGray);
      margin-bottom: 20px;

      > span {
        color: #db6e20;
      }
    }

    .login-desc {
      color: var(--productGray);
      font-size: 14px;
      margin: 10px 0;
      font-weight: normal;

      .italic {
        margin-bottom: 5px;
        display: block;
        font-style: italic;
      }
    }

    .login-alert {
      margin: 20px 0;
    }

    .login-forgot {
      font-size: 14px;
      color: #000000;

      .login-bold-click {
        font-weight: bold;
        cursor: pointer;
      }
    }

    .login-button {
      margin-top: 0;
      background: #db6e20 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      padding: 20px 20px;
      font: Bold 14px/17px Raleway;
      color: #ffffff;
    }

    .login-input {
      border: 1px solid #000000 !important;
      height: 3rem !important;
      border-radius: 2px;
    }

    .login-form-item {
      .ant-form-item-required {
        font-size: 16px;
        line-height: 25px;
        color: #000000;
      }
    }
  }

  .login-bottom {
    position: relative;
    width: 100%;
    padding: 21px;
    background: #fff;
    align-items: center;
    display: flex;
    justify-content: center;
    font-weight: bold;
    border-top: 1px solid #707070;

    @media (max-width: 600px) {
      display: none;
    }
  }
`;

export default ConfirmEmail;
export const Route = createFileRoute('/confirm-email/')({ component: ConfirmEmail });
